<template>
    <!-- Modal -->
    <div class='modal fade' id='word-paragraph-documents' tabindex='-1' role='dialog'
         aria-labelledby='modal-" . $item->id . "-label' aria-hidden='true'>
        <div class='modal-dialog' role='document'>
            <div class='modal-content'>
                <div class='modal-header'>
                    <h5 class='modal-title'>Word Paragraph -
                        #{{ $store.getters["word_paragraphs/wordParagraphId"] }}</h5>
                    <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
                        <span aria-hidden='true'>&times;</span>
                    </button>
                </div>
                <div class='modal-body'>
                    <span v-if="loading">Loading...</span>
                    <span v-else v-for="(item, index) in items" :key="index" v-html="item.btn"></span>
                </div>
                <div class='modal-footer'>
                    <button type='button' class='btn btn-info' data-dismiss='modal'>Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "WordParagraphDocument",
    props: {},
    data: function () {
        return {
            items: [],
            loading: false
        }
    },
    watch: {
        '$store.state.word_paragraphs.wordParagraphId' (val){
            this.documents();
        }
    },
    methods: {
        documents() {
            var app = this;
            let id =  this.$store.getters['word_paragraphs/wordParagraphId']
            this.loading = true;
            axios.get(`/word_paragraphs/${id}/documents`)
            .then(function (response){
                app.items = response.data;
                app.loading = false;
            }) .catch(error => {
                app.loading = false;
            })
        }
    }
}
</script>

<style scoped>

</style>
